<script setup>
import {inject} from "vue";

const props = defineProps({
    channelId: {
        type: Number,
        required: true
    }
})

const isVisible = inject('containerTabIsVisible')

</script>

<template>
    <community-progress-tracking-report
        v-if="isVisible"
        :channel-id="channelId"
    ></community-progress-tracking-report>
</template>
